require('angular').module('wowApp.shop')
    .factory('config', ['BootstrapService', require('./config-factory')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/config/index.js
 **/